import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="number-series--sanitizer"
export default class extends Controller {
  static targets = ["numberSeriesId", "numberSeriesInput"]
  static values = {
    numberSeriesId: String
  }

  // Keep the document linked to its number series even when the number is
  // edited by hand. A manual number is safe — the DB unique index and the
  // server-side collision scan handle it — whereas detaching would orphan the
  // document (it would fall outside the series' unique index) and desync the
  // counter. To set a different series (or none), use the series picker.
  sanitizeNumberSeriesId() {
    this.numberSeriesIdTarget.value = this.numberSeriesIdValue
  }

  // this will ensure that input events on inputTarget are called when change is detected
  triggerEventOnChange() {
    const event = new Event("input", { bubbles: true })
    this.numberSeriesInputTarget.dispatchEvent(event)
  }

  setNumberSeriesIdAttribute(id) {
    this.numberSeriesIdValue = id
  }
}
